<template>
  <div class="phone" @click="hideReplyPopup">
    <div  v-if="!composeEmailLoading">
      <!-- Primary header -->
      <header-vue/>

      <transition name="swipe" mode="out-in">
        <!-- The mail details view section goes here -->
        <div id="view-email">
          <div class="view-email-header">
            <div class="email-from" v-if="mailDetail.from && mailDetail.from.length > 0">
              <div class="lhs txt-b">From</div>
              <div class="rhs">
                <ul class="email-list-container">
                  <li v-for="mail in mailDetail.from" :key="mail.id">
                    <a href="javascript:void(0)"> {{ mail.name }} <span>&lt;{{ mail.email }}&gt;</span></a>
                  </li>
                </ul>
              </div>
              <div class="clear"></div>
            </div>

            <!--Email To-->
            <div class="email-to" v-if="mailDetail.to && mailDetail.to.length > 0">
              <div class="lhs txt-b">To</div>
              <div class="rhs">
                <ul class="email-list-container">
                  <li v-for="mail in mailDetail.to.slice(0, 4)" :key="mail.id">
                    <a href="javascript:void(0)">{{ mail.name }} <!--<span>&lt;{{ mail.email }}&gt;</span>--></a>
                  </li>
                  <li v-if="mailDetail.to.slice(4).length > 0">
                    <span
                      @click="toggleContactList('to')"
                      class="to-email-count"
                    >
                      {{ `+${mailDetail.to.slice(4).length}` }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="clear"></div>
            </div>

            <!--Email CC-->
            <div class="email-cc" v-if="mailDetail.cc && mailDetail.cc.length > 0">
              <div class="lhs txt-b">Cc</div>
              <div class="rhs">
                <ul class="email-list-container">
                  <li v-for="mail in mailDetail.cc.slice(0, 4)" :key="mail.id">
                    <a href="javascript:void(0)"> {{ mail.name }} <!--<span>&lt;{{ mail.email }}&gt;</span>--></a>
                  </li>
                  <li v-if="mailDetail.cc.slice(4).length > 0">
                    <span
                      class="to-email-count"
                      @click="toggleContactList('cc')"
                    >
                      {{ `+${mailDetail.cc.slice(4).length}` }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="clear"></div>
            </div>

            <!--Email BCC-->
            <div class="email-cc" v-if="mailDetail.bcc && mailDetail.bcc.length > 0">
              <div class="lhs txt-b">Bcc</div>
              <div class="rhs">
                <ul class="email-list-container">
                  <li v-for="mail in mailDetail.bcc.slice(0, 4)" :key="mail.email">
                    <a href="javascript:void(0)"> {{ mail.name }} <!--<span>&lt;{{ mail.email }}&gt;</span>--></a>
                  </li>
                  <li v-if="mailDetail.bcc.slice(4).length > 0">
                    <span
                      @click="toggleContactList('bcc')"
                      class="to-email-count"
                    >
                      {{ `+${mailDetail.bcc.slice(4).length}` }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="clear"></div>
            </div>

            <!--Email Received Time-->
            <div class="email-received">
             <div class="lhs txt-b">Received</div>
             <div class="rhs">{{ this.mailDetail.sentTime }}</div>
             <div class="clear"></div>
            </div>
          </div>

          <!-- The contact list pop-up section goes here. -->
          <transition name="pop-up">
            <div class="exceeding-emailist-con" v-if="showContactList">
              <div class="ex-to-header">
                <h3>
                  {{ `${contactListToDisplay[0].toUpperCase() + contactListToDisplay.slice(1)} : List of email ids` }}
                </h3>
                <a @click="toggleContactList" href="javascript:void(0)">Close</a>
              </div>

              <ul class="exceeding-emailist" v-if="'to' === contactListToDisplay">
                <li v-for="mail in mailDetail.to" :key="mail.id">
                  {{ mail.name }}
                </li>
              </ul>

              <ul class="exceeding-emailist" v-if="'cc' === contactListToDisplay">
                <li v-for="mail in mailDetail.cc" :key="mail.id">
                  {{ mail.name }}
                </li>
              </ul>

              <ul class="exceeding-emailist" v-if="'bcc' === contactListToDisplay">
                <li v-for="mail in mailDetail.bcc" :key="mail.id">
                  {{ mail.name }}
                </li>
              </ul>
            </div>
          </transition>

          <div class="view-email-content">
            <!--Email Subject-->
            <div class="email-subject">{{ mailDetail.subject }}</div>

            <!--Email Attachment-->
            <div class="email-attachment" v-if="mailDetail.attachments && mailDetail.attachments.length > 0">
              Attachment:
              <ul>
                <li v-for="attachment in mailDetail.attachments" :key="attachment.id" >
                  <a href="javascript:void(0)" @click="downloadAttachment(attachment.mailAttachmentId, attachment.name)">
                    {{
                    attachment.name.length > 20 ?
                    attachment.name.substring(0, 20) + '...' + attachment.name.split('.').pop() :
                    attachment.name
                    }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Email Body -->
            <div class="email-body">
              <p v-html="mailDetail.message">
              </p>
            </div>

            <!--Email Attachment-->
            <!--<div class="email-attachment" v-if="mailDetail.attachments && mailDetail.attachments.length > 0">
              Attachment:
              <ul>
                <li v-for="attachment in mailDetail.attachments" :key="attachment.id" >
                  <a href="javascript:void(0)" @click="downloadAttachment(attachment.mailAttachmentId, attachment.name)">
                    {{
                      attachment.name.length > 20 ?
                      attachment.name.substring(0, 20) + '...' + attachment.name.split('.').pop() :
                      attachment.name
                    }}
                  </a>
                </li>
              </ul>
            </div>-->
          </div>

          <!--Reply Popup-->
          <transition name="pop-up">
            <div class="reply-container" v-show="showReplyPopUp" @click="event => event.stopPropagation()">
              <ul class="reply-options">
                <li @click="replyMail('reply')">
                  <a href="javascript:void(0)">
                    <span class="icon reply-email">
                      <img src="../../../assets/img/icon-reply-email.png" alt="Reply" />
                    </span>
                    <span>Reply</span>
                  </a>
                </li>
                <li @click="replyMail('replyAll')">
                  <a href="javascript:void(0)">
                    <span class="icon reply-all">
                      <img src="../../../assets/img/icon-reply-all.png" alt="Reply All" />
                    </span>
                    <span>Reply All</span>
                  </a>
                </li>
                <li @click="replyMail('forward')">
                  <a href="javascript:void(0)">
                    <span class="icon forward">
                      <img src="../../../assets/img/icon-forward-email.png" alt="Forwarad Email" />
                    </span>
                    <span>Forward</span>
                  </a>
                </li>
                <li @click="deleteMail">
                  <a href="javascript:void(0)">
                    <span class="icon trash">
                      <img src="../../../assets/img/icon-email-trash.png" alt="Trash Email" />
                    </span>
                    <span>Trash</span>
                  </a>
                </li>
              </ul>
              <ul class="reply-other-cta">
                <!--<li @click="markFavourite">
                  <a href="javascript:void(0)">
                    <span v-if="'0' === mailDetail.isFavourite">Mark As Favorite</span>
                    <span v-else>Unmark Favorite</span>
                    <span class="icon favourite-email">
                      <img src="../../../assets/img/icon-email-favourites.png" alt="Favourite Email" />
                    </span>
                  </a>
                </li>-->
                <li @click="changeReadStatus">
                  <a href="javascript:void(0)">
                    <span>Mark Unread</span>
                    <span class="icon unread-email">
                      <img src="../../../assets/img/icon-email-unread.png" alt="Unread Email" /></span>
                  </a>
                </li>
                <li @click="toggleMoveClick" v-if="'inbox' === mailDetail.mailCategory">
                  <a href="javascript:void(0)">
                    <span>Move Message</span>
                    <span class="icon move-email">
                      <img src="../../../assets/img/icon-move-email.png" alt="Move Email" />
                    </span>
                  </a>
                </li>
                <li @click="deleteMail">
                  <a href="javascript:void(0)">
                    <span>Trash</span>
                    <span class="icon trash-email">
                      <img src="../../../assets/img/icon-email-trash.png" alt="Trash Email" />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </div>

      </transition>

      <!-- The move email component -->
      <move-email-vue v-if="moveClicked" :mailDetails="mailDetail" v-on:hideMoveEmail="toggleMoveClick" />

      <!-- The footer section goes here -->
      <footer-vue
        v-show="!showReplyPopUp"
        v-on:toggleMoreBtn="toggleMoreBtn"
        v-on:deleteMailClicked="deleteMail"
        v-on:editDraft="editDraft"
        v-on:replyMail="replyMail"
        v-on:toggleMoveClick="toggleMoveClick"
        :type="mailDetail.mailCategory" />
    </div>
    <transition name="fade" v-else>
      <div class="loader-container">
        <loader-vue />
      </div>
    </transition>
  </div>
</template>

<script>
  import HeaderVue from "./Header.vue";
  import FooterVue from "./Footer.vue";
  import { mapGetters, mapMutations, mapActions } from "vuex";
  import LoaderVue from "../../Appointment/common/Loader";
  import MoveEmailVue from "./MoveEmail.vue";
  import { mailFolder } from "../../../mixins/mailFolder";
  import axios from "axios";
  import { ERROR_MESSSAGE } from "../../../store/config";
  import Vue from "vue";

  export default {
    data() {
      return {
        mailId: null,
        mailType: null,
        mailDetail: {},
        deleteMailClicked: false,
        showReplyPopUp: false,
        moveClicked: false,
        str: 'https://test.psybooks.com/getfile.php?attachmentid=300&amp;type=mail',
        showContactList: false,
        contactListToDisplay: false
      };
    },
    mixins: [mailFolder],
    components: {
      HeaderVue,
      FooterVue,
      LoaderVue,
      MoveEmailVue
    },
    computed: {
      ...mapGetters("portalemail", {
        composeEmailLoading: "getComposeEmailLoading",
        emailFolder: "getEmailFolder",
        boxCount: "getBoxCount",
        selectedUserId: "getSelectedUserId"
      }),
    },
    methods: {
      ...mapMutations("portalemail", {
        setComposeEmailLoading: "setComposeEmailLoading",
        setInitialMailDetails: "setInitialMailDetails",
        addRemoveFavourite: "addRemoveFavourite",
        markEmailAsRead: "markEmailAsRead",
        removeItemFromUnreadMails: "removeItemFromUnreadMails",
        addItemsToUnreadMails: "addItemsToUnreadMails",
        resetEmails: "resetEmails",
        setBoxCount: "setBoxCount"
      }),
      ...mapActions("portalemail", {
        loadMailDetail: "loadMailDetail",
        loadFolderList: "loadFolderList",
        fetchMailCount: "fetchMailCount"
      }),

      /**
       * Functionality for toggling the reply button
       */
      toggleMoreBtn(event) {
        event.stopPropagation();
        this.showReplyPopUp = !this.showReplyPopUp;
      },

      /**
       * Function to toggle contact list display
       */
      toggleContactList(contactListToDisplay = null) {
        if(contactListToDisplay) {
          this.contactListToDisplay = contactListToDisplay;
        }

        this.showContactList = !this.showContactList;
      },

      /**
       * Functionality on clicking reply/forward/reply-all
       */
      replyMail(replyType) {
        let replyMailDetail = {
          message: '',
          toArray: [],
          ccArray: [],
          bccArray: [],
          subject: '',
          attachments: [],
          mailId: this.mailId
        };

        // Constructing mail content
        let msgType = ('reply' === replyType || 'replyAll' === replyType) ? 'Original message' : 'Forwarded message';
        replyMailDetail.message = this.getHtmlContent(this.mailDetail, msgType);

        // Getting user info
        let userInfo = this.$store.getters.userInfo;

        if('forward' !== replyType) {

          let from = this.selectedUserId ? this.selectedUserId : userInfo.userId;
          if(replyType === 'replyAll') {

            // Constructing to Array
            if(typeof this.mailDetail.to != 'undefined' && this.mailDetail.to.length > 0) {
              this.mailDetail.to.forEach((toDetail , index) => {
                if((2 === this.mailType) || (Number(from) !== Number(this.mailDetail.to[index].id))) {
                  replyMailDetail.toArray.push(Number(this.mailDetail.to[index].id));
                }
              });
            }

            // Constructing CC Array
            if(typeof this.mailDetail.cc != 'undefined' && this.mailDetail.cc.length > 0) {
              this.mailDetail.cc.forEach((ccDetail, i) => {
                if((2 === this.mailType) || (Number(from) !== Number(this.mailDetail.cc[i].id))) {
                  replyMailDetail.ccArray.push(Number(this.mailDetail.cc[i].id));
                }
              });
            }

            // Constructing BCC Array
            if(typeof this.mailDetail.bcc != 'undefined' && this.mailDetail.bcc.length > 0) {
              this.mailDetail.bcc.forEach((bccDetail, i) => {
                if((2 === this.mailType) || (Number(from) !== Number(this.mailDetail.bcc[i].id))) {
                  replyMailDetail.bccArray.push(Number(this.mailDetail.bcc[i].id));
                }
              });
            }

            // Pushing the from details to to-array
            if(2 !== this.mailType) {
              if (typeof this.mailDetail.from != 'undefined' && this.mailDetail.from.length > 0) {
                this.mailDetail.from.forEach((fromDetail, i) => {
                  // if(Number(from) !== Number(this.mailDetail.from[i].id)) {
                  replyMailDetail.toArray.push(Number(this.mailDetail.from[i].id));
                  // }
                });
              }
            }
          }

          // If there is any mail on sent folder and user is clicking reply button for that mail
          if ('reply' === replyType) {
            if(2 === this.mailType) {
              this.mailDetail.to.forEach((toDetail, index) => {
                //if (Number(from) !== Number(this.mailDetail.to[index].id)) {
                  replyMailDetail.toArray.push(Number(this.mailDetail.to[index].id));
                //}
              });
            }

            if((1 === this.mailType) && (typeof this.mailDetail.from != 'undefined' && this.mailDetail.from.length > 0)) {
              this.mailDetail.from.forEach((fromDetail, i) => {
                replyMailDetail.toArray.push(Number(this.mailDetail.from[i].id));
              });
            }
          }
        }

        if(replyType === 'replyAll' || replyType === 'reply') {
          replyMailDetail.subject = 'Re:' + this.mailDetail.subject;
        } else if(replyType === 'forward') {
          replyMailDetail.subject = 'Fwd:' + this.mailDetail.subject;
        }

        if(this.mailDetail.attachments && this.mailDetail.attachments.length > 0) {
          this.mailDetail.attachments.forEach(attachment => {
            attachment.hideCloseIcon = true;
            replyMailDetail.attachments.push(attachment);
          });
        }

        // The mail type
        replyMailDetail.mailActionType = replyType;

        this.setInitialMailDetails(replyMailDetail);
        this.$router.push("/compose-email");
      },

      /**
       * The delete mail functionality
       */
      async deleteMail() {
        this.setComposeEmailLoading(true);
        let deleteMailRes = await this.$store.dispatch(
          "makeAuthRequest",
          {
            url: "portalemail/movetotrash",
            method: "PUT",
            chat: true,
            data: {
              selectedMails: [this.mailId],
              boxType: this.mailType,
              selectedSubscriberId: this.$store.getters.getSelectedProviderID,
              appUserId: this.selectedUserId
            }
          },
          {
            root: true
          }
        );
        this.setComposeEmailLoading(false);

        if(deleteMailRes.error) {
          this.$store.dispatch("globalMessagePopup", deleteMailRes.error);
        } else {
          this.resetEmails({boxType: 'all', folderId: 0});
          this.setBoxCount({
            key: 'needLoad',
            value: true
          });
          return this.$router.push(this.$store.getters.getPreviousRoute);
        }
      },

      /**
       * Function to download any attachment
       *
       * @param attachmentId
       * @param attachmentName
       */
      async downloadAttachment(attachmentId, attachmentName) {
        axios({
          url: `/email/downloadAttachment/${attachmentId}/${this.$store.getters.getSelectedProviderID}`,
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "multipart/form-data; charset=UTF-8",
            token: this.$store.getters.userInfo.token,
            userid: this.$store.getters.userInfo.userId
          },
          redirect: "follow",
          referrer: "no-referrer",
          responseType: 'blob'
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', attachmentName);
          document.body.appendChild(link);
          link.click();
        }).catch(err => {
          const res = err.response;

          // Logout when user is unauthorized
          if (res != undefined) {
            if (res.status === 401) {
              this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE[401]);
              if (this.$store.getters.checkSession) {
                this.$store.dispatch("logout");
              }
              return;
            }
          }
        });
      },

      /**
       * Functionality on clicking mark-unread
       */
      async changeReadStatus() {
        this.setComposeEmailLoading(true);
        let markUnreadRes = await this.$store.dispatch(
          "makeAuthRequest",
          {
            url: "portalemail/changeReadStatus",
            method: "PUT",
            chat: true,
            data: {
              boxType: this.mailType,
              mailIdArray: [this.mailId],
              readStatus: 0,
              selectedSubscriberId: this.$store.getters.getSelectedProviderID,
              appUserId: this.selectedUserId
            }
          },
          {
            root: true
          }
        );
        this.setComposeEmailLoading(false);

        if(markUnreadRes.error) {
          this.$store.dispatch("globalMessagePopup", markUnreadRes.error);
        } else {
          this.resetEmails({boxType: 'all', folderId: 0});
          this.setBoxCount({
            key: 'needLoad',
            value: true
          });
          this.addItemsToUnreadMails({isIncreaseCount: 0 === this.selectedUserId, mailId: this.mailId});
          return this.$router.push(`/emails/unread`);
        }
      },

      /**
       * Functionality on clicking mark/un-mark favourite
       */
      async markFavourite() {
        this.setComposeEmailLoading(true);
        // Marking/removing mail from favourite list
        let favRes = await this.$store.dispatch(
          "makeAuthRequest",
          {
            url: 'portalemail/' + ('0' === this.mailDetail.isFavourite ? 'addFavourite' : 'removeFavourite'),
            method: "POST",
            chat: true,
            data: {
              mailbox_id: this.mailId,
              selectedSubscriberId: this.$store.getters.getSelectedProviderID,
              appUserId: this.selectedUserId
            }
          },
          {
            root: true
          }
        );

        // Commit the required mutation
        this.addRemoveFavourite({
          mailId: this.mailId,
          boxType: this.$route.params.type,
          folderId: this.mailDetail.folder_id ? this.mailDetail.folder_id : 0,
          isAdd: '0' === this.mailDetail.isFavourite
        });
        this.mailDetail.isFavourite = ('0' === this.mailDetail.isFavourite ? '1' : '0');
        this.setComposeEmailLoading(false);

        // Showing error message on error
        if(favRes.error) {
          this.$store.dispatch("globalMessagePopup", favRes.error);
        }

        if(this.mailDetail.error) {
          this.$store.dispatch("globalMessagePopup", this.mailDetail.error);
        }
      },

      /**
       * Functionality on clicking move message section
       */
      async toggleMoveClick() {
        if(!this.moveClicked) {
          if (!this.emailFolder) {
            this.setComposeEmailLoading(true);
            await this.loadFolderList();
            this.setComposeEmailLoading(false);
          }

          /*if(this.boxCount.needLoad) {
            this.setComposeEmailLoading(true);
            await this.fetchMailCount();
            this.setComposeEmailLoading(false);
          }*/
        }

        Vue.nextTick(() => {
          this.moveClicked = !this.moveClicked;
        });
      },

      /**
       * Edit draft functionality
       */
      editDraft() {
        let userInfo = this.$store.getters.userInfo;
        let from = this.selectedUserId ? this.selectedUserId : userInfo.userId;

        let mailDetail = {
          message: this.mailDetail.message,
          toArray: [],
          ccArray: [],
          bccArray: [],
          subject: this.mailDetail.subject,
          mailId: this.mailId
        };

        // Inserting all the to details
        if(typeof this.mailDetail.to != 'undefined' && this.mailDetail.to.length > 0) {
          this.mailDetail.to.forEach((toDetail, i) => {
            if(Number(from) !== Number(this.mailDetail.to[i].id)) {
              mailDetail.toArray.push(Number(this.mailDetail.to[i].id));
            }
          });
        }

        // Inserting the from details. It's not in used currently. Will be removed in future.
        if(typeof this.mailDetail.from != 'undefined' && this.mailDetail.from.length > 0) {
          this.mailDetail.from.forEach((fromDetail, i) => {
            if(Number(from) !== Number(this.mailDetail.from[i].id)) {
              mailDetail.toArray.push(Number(this.mailDetail.from[i].id));
            }
          });
        }

        // Inserting all the CC details
        if(typeof this.mailDetail.cc != 'undefined' && this.mailDetail.cc.length > 0) {
          this.mailDetail.cc.forEach((ccDetail, i) => {
            if(Number(from) !== Number(this.mailDetail.cc[i].id)) {
              mailDetail.ccArray.push(Number(this.mailDetail.cc[i].id));
            }
          });
        }

        // Inserting all the bcc details.
        if(typeof this.mailDetail.bcc != 'undefined' && this.mailDetail.bcc.length > 0) {
          this.mailDetail.bcc.forEach((bccDetail, i) => {
            if(Number(from) !== Number(this.mailDetail.bcc[i].id)) {
              mailDetail.bccArray.push(Number(this.mailDetail.bcc[i].id));
            }
          });
        }

        // The attachments are attached
        mailDetail.attachments = this.mailDetail.attachments;

        // The mail type
        mailDetail.mailActionType = 'edit';

        // The mail signatures
        mailDetail.signature = this.mailDetail.signature;

        // Setting the mail details on vuex-state and redirecting to compose email page.
        this.setInitialMailDetails(mailDetail);
        this.$router.push("/compose-email");
      },

      /**
       * Hide reply Pop-Up
       */
      hideReplyPopup() {
        if (this.showReplyPopUp) {
          this.showReplyPopUp = false;
        }
      },

      /**
       * Function to load page initial data
       */
      async loadPageInitialData() {
        // Validating Mail Id
        this.mailId = parseInt(this.$route.params.id);
        if(this.mailId <= 0) {
          this.$router.go(-1);
        }

        // Validating mail type
        if('inbox' === this.$route.params.type) {
          this.mailType = 1;
        } else if('sent' === this.$route.params.type) {
          this.mailType = 2;
        } else if('draft' === this.$route.params.type) {
          this.mailType = 0;
        } else if('trash' === this.$route.params.type) {
          this.mailType = 3;
        } else {
          this.$router.go(-1);
        }

        this.setComposeEmailLoading(true);

        // Fetching mail detail
        this.mailDetail = await this.loadMailDetail({
          mailId: this.mailId,
          mailType: this.mailType
        });

        // Remove items from unread mails
        this.removeItemFromUnreadMails({
          decreaseCount: (0 === Number(this.selectedUserId)),
          mailId: this.mailId
        });

        // Handling error
        if(this.mailDetail.error) {
          if((403 === this.mailDetail.code)) {
            if('/login' === this.$store.getters.getPreviousRoute) {
              this.$router.push("/daily");
            } else {
              this.$router.go(-1);
            }
          } else {
            this.$store.dispatch("globalMessagePopup", this.mailDetail.error);
          }
        } else {

          // Mark email as read
          this.markEmailAsRead({
            mailId: this.mailId,
            boxType: this.$route.params.type,
            folderId: this.mailDetail.folder_id ? this.mailDetail.folder_id : 0
          });

        }

        this.setComposeEmailLoading(false);
      }
    },

    /**
     * Fetching mail details on created hook
     */
    async created() {
      this.loadPageInitialData();
    },

    watch: {
      $route(to, from) {
        if(to !== from) {
          this.loadPageInitialData();
        }
      }
    }
  };
</script>

<style scoped>

  .contacts-container, .exceeding-emailist-con{
    width:98%;
    background:#fff;
    left:10px;
    top:45px;
    position:absolute;
    z-index:9;
    border-radius:5px;
    border:1px solid #ddd;
  }
  .contacts-container.collapsed, .exceeding-emailist-con.collapsed{
    position:fixed;
    bottom:0!important;
    max-height:94px;
    top:unset;

  }

  .contacts-header{
    position:relative;
    background:#f6f6f6;
    padding:10px;
    text-align: center;

  }
  .contacts-header h2{
    font-size:18px;
    font-weight: bold;
    margin:0 0 15px;
    position: relative;
  }
  .contacts-header h5{
    font-size:14px;
    margin:10px 0 15px;
  }
  .contacts-header a{
    font-weight: bold;
    font-size:14px;
    position:absolute;
    right: 10px;
    top:10px;
  }

  .all-contacts-list, .exceeding-emailist{
    padding:10px;
  }
  .all-contacts-list li, .exceeding-emailist li{
    padding:10px 0;
    margin:10px 0;
    border-bottom:1px solid #ddd;
    position:relative;
  }
  .all-contacts-list li:last-child, .exceeding-emailist li:last-child{
    border-bottom:none;
  }
  .ex-to-header{
    position:relative;
    margin:20px 10px 0;
  }
  .ex-to-header h3{
    font-weight: bold;
  }
  .ex-to-header a{
    position:absolute;
    right:10px;
    top:10px;
  }
  .exceeding-emailist{
    padding:10px;
  }

  @media screen and (max-width:768px){
    .contacts-container{
      width:calc(100% - 20px);
    }
  }

  ::v-deep .forwardedMessage {
    margin-top: 20px !important;
    padding-left: 10px !important;
    border-left: 1px solid gray !important;
  }
   ::v-deep  #forwardedMessageDiv > div{
    margin:0!important;
    width:auto!important;
    font-family: sans-serif!important;
    font-size:14px!important;
  }
   ::v-deep  #forwardedMessageDiv > div h2 {
    margin:10px!important;
    width:auto!important;
    font-family: sans-serif!important;
    font-size:18px!important;
    font-weight: bold!important;
  }
 ::v-deep  #forwardedMessageDiv > div p {
    margin:10px!important;
    width:auto!important;
    font-family: sans-serif!important;
  }
  @media screen and (max-width:767px){
      ::v-deep .forwardedMessage {
        min-height: 50vh;
        overflow-y:scroll;
      }

  }



  @keyframes swipeIn {
    from {
      opacity: 0;
      transform: translateX(-100px);
    }

    50% {
      opacity: 0.5;
      transform: translateX(-50px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes swipeOut {
    from {
      opacity: 1;
      transform: translateX(0);
    }

    50% {
      opacity: 0.5;
      transform: translateX(-50px);
    }

    to {
      opacity: 0;
      transform: translateX(-100px);
    }
  }
  #view-email{
    width:97%;
    margin:0 auto 20px;
    position:relative;
    top:110px;
  }
  .view-email-header{
    border-bottom:1px solid #ddd;
    font-size:14px;
  }
  .lhs{
    float:left;
    width:70px;
    margin-bottom:15px;
  }
  .rhs{
    float:left;
      width: calc(100% - 80px);
      margin-bottom:15px;

  }
  .clear{
    clear:both;
  }
  .view-email-content{
    margin:10px auto;
    height: calc(100vh - 200px)!important;
    overflow-y:auto;
  }
  .view-email-content .email-subject{
    float:none;
    font-size:16px;
    color:#d26d13;
    max-width:100%;
  }
  .email-subject{
    font-size:16px;
    margin-bottom:10px;
    font-weight: bold;
    float: right;
    max-width:75%;
  }
  .email-body{
    font-size:16px;
    line-height: 22px;
    position:relative;
    margin-bottom:70px;

  }
  .txt-b{
    font-weight: bold;
  }
  .email-list-container{
    padding:0;
    margin:0;
    list-style:none;
  }
    .email-list-container li{
    padding:0;
    margin:0 0 5px;
    display:inline-block;
  }
  .email-list-container li a{
    color:#000;
  }
  .email-list-container li a:hover{
    color:#d26d13;
  }
 .email-to .rhs .email-list-container li,  .email-cc .rhs .email-list-container li{
    margin-right: 5px;
    border:1px solid #ddd;
    padding:3px 5px;
    border-radius: 3px;
  }
   .email-to .rhs .email-list-container li:last-child,  .email-cc .rhs .email-list-container li:last-child{
    border:none;
  }
  .to-email-count{
    font-size:12px;
    border:1px solid #ddd;
    padding:3px 5px;
    border-radius: 3px;
    color:#d26d13;
    cursor: pointer;
  }
  .reply-container{
    padding:0;
    position:fixed;
    bottom:0;
    background:#ccc;
    width:100%;
    left:0;
  }
  .reply-options{
margin:20px auto;
padding:0;
list-style:none;
display:flex;
justify-content:space-around;
align-items:center;
width:96%;
}
.reply-options li{
background:#fff;
display:block;
border-radius: 5px;
padding:10px 5px 15px;
    width: calc(100% - 10px);
    margin: 0 20px 0 0;
    text-align: center;

}
.reply-options li:last-child{
  margin-right: 0;

}
.reply-options li a{
  color:#5888c5;
    font-weight: bold;

}
.reply-options li a:hover{
  color:#d26d13;
}
.reply-options span.icon{
  display:block;
  width:24px;
  height: 24px;
  margin:0 auto 5px;
  text-align:center;
}
.reply-options li a img{
  max-width:24px;
}
.reply-other-cta{
margin:0 auto 20px;
padding:0;
list-style:none;
display:block;
width:96%;

}
.reply-other-cta li{
background:#fff;
display:block;
padding:10px;
    width: calc(100% - 20px);
    margin: 0 0 20px 0;
border-radius: 5px;
position: relative;
}
.reply-other-cta span.icon{
  position:absolute;
  right: 20px;
  top:2px;
  display:block;
  width:24px;
  height: 24px;
}

/* This animation is for reply pop-up */
  .pop-up-enter-active {
    animation: fade-in-up 0.2s ease-in-out forwards;
  }

  .pop-up-leave-active {
    animation: fade-in-down 0.2s ease-in-out forwards;
  }
  .email-attachment{
    margin:0 0 10px;
    border-top: 1px solid #ddd;
    border-bottom:1px solid #ddd;
    padding-top: 10px;
    font-weight: bold;
    max-height: 130px;
    position:relative;
  }
  .email-attachment ul{
    margin:5px 0 10px 0px;
    font-weight: normal;
    max-height:100px;
    overflow-y:scroll;
  }
  .email-attachment ul li{
    margin:10px 10px 10px 0;
    vertical-align: text-bottom;
    padding-bottom:0;
    display: inline-block;
    font-size:14px;
  }
  @keyframes fade-in-up {
    from {
      transform: translate3d(0,40px,0);
      opacity: 0;
    }

    to {
      transform: translate3d(0,0,0);
      opacity: 1;
    }
  }

  @keyframes fade-in-down {
    from {
      transform: translate3d(0,0,0);
      opacity: 1;
    }

    to {
      transform: translate3d(0,40px,0);
      opacity: 0;
    }
  }


  /* This animation is for user list */
  .pop-up-enter-active {
    animation: fade-in-up 0.2s ease-in-out forwards;
  }

  .pop-up-leave-active {
    animation: fade-in-down 0.2s ease-in-out forwards;
  }
  @keyframes fade-in-up {
    from {
      transform: translate3d(0,40px,0);
      opacity: 0;
    }

    to {
      transform: translate3d(0,0,0);
      opacity: 1;
    }
  }

  @keyframes fade-in-down {
    from {
      transform: translate3d(0,0,0);
      opacity: 1;
    }

    to {
      transform: translate3d(0,40px,0);
      opacity: 0;
    }
  }
</style>
